import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";

export default function FootballPitch({ players = [] }) {
  // Default positions for 5-a-side
  const positions = [
    { style: { top: "15%", left: "50%" }, role: "Gardien" },
    { style: { top: "38%", left: "22%" }, role: "Defenseur" },
    { style: { top: "38%", left: "78%" }, role: "Defenseur" },
    { style: { top: "60%", left: "50%" }, role: "Milieu" },
    { style: { top: "85%", left: "50%" }, role: "Attaquant" },
  ];

  const displayPlayers = players.slice(0, 5);

  return (
    <div
      data-testid="football-pitch"
      className="relative w-full aspect-[3/4] max-w-xs mx-auto rounded-xl overflow-hidden"
    >
      {/* Pitch Background */}
      <div 
        className="absolute inset-0 rounded-xl"
        style={{
          background: `repeating-linear-gradient(180deg, #15803d 0px, #15803d 28px, #16a34a 28px, #16a34a 56px)`,
        }}
      >
        <div className="absolute inset-2 border-2 border-white/80 rounded-lg">
          <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-white/80 -translate-y-1/2" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 border-2 border-white/80 rounded-full" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white/80 rounded-full" />
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-12 border-2 border-t-0 border-white/80 rounded-b" />
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-6 border-2 border-t-0 border-white/80 rounded-b" />
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-32 h-12 border-2 border-b-0 border-white/80 rounded-t" />
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-20 h-6 border-2 border-b-0 border-white/80 rounded-t" />
        </div>
      </div>

      {/* Players */}
      {displayPlayers.map((player, index) => (
        <div
          key={player.id}
          data-testid={`player-${player.id}`}
          className="absolute flex flex-col items-center gap-1 z-10"
          style={{
            ...positions[index]?.style,
            transform: "translate(-50%, -50%)",
          }}
        >
          <div className="relative">
            <Avatar className="w-11 h-11 border-2 border-white shadow-lg ring-2 ring-[#22c55e]/50">
              <AvatarFallback className="bg-[#22c55e] text-white font-bold text-sm">
                {player.name?.charAt(0) || "?"}
              </AvatarFallback>
            </Avatar>
            {index === 0 && (
              <div className="absolute -top-1 -right-1 text-sm drop-shadow-lg">🥇</div>
            )}
          </div>
          <div className="bg-black/90 backdrop-blur-sm px-2 py-0.5 rounded-md shadow-lg">
            <p className="text-[10px] font-semibold text-white truncate max-w-[60px] text-center">
              {player.name}
            </p>
            <div className="flex justify-center">
              <Badge className="text-[9px] bg-[#22c55e] text-white hover:bg-[#22c55e] px-1.5 py-0 border-0">
                {player.rating?.toFixed(1) || "5.0"}
              </Badge>
            </div>
          </div>
        </div>
      ))}

      {displayPlayers.length === 0 && (
        <div className="absolute inset-0 flex items-center justify-center">
          <p className="text-white/60 text-sm">Pas encore de joueurs</p>
        </div>
      )}
    </div>
  );
}
